import AppService from "Global/AppService";
import * as QCAssaySummContants from './QCAssaySummConstants';

export const addDeviceToQCAssaySummReducerState = (instanceId) => {
	return {
		type: QCAssaySummContants.QC_ASSAY_STATE_ADD,
		payload: instanceId
	}
};

export const removeDeviceToQCAssaySummReducerState = (instanceId) => {
	return {
		type: QCAssaySummContants.QC_ASSAY_STATE_REMOVE,
		payload: instanceId
	}
};

export const getQCSummData = (url,payload,deviceId) => {
	
	return (dispatch) => {
		dispatch({ type: QCAssaySummContants.QC_ASSAY_SUMMARY_DATA_FETCHING,payload:deviceId });

		function callback(success, err) {
			
			if (success?.result) {
				dispatch(getQCSummDataSuccess(success,deviceId));
			} else {
				dispatch(getQCSummDataFailure(deviceId));
			}
		}

		AppService.postData(payload, url, callback);
	}
}

export const getQCSummDataSuccess = (successResponse,deviceId) => {
	return { type: QCAssaySummContants.QC_ASSAY_SUMMARY_DATA_FETCHED, payload:{newState: successResponse,deviceId:deviceId} };
}

export const getQCSummDataFailure = (deviceId) => {
	return { type: QCAssaySummContants.QC_ASSAY_SUMMARY_DATA_FETCHING_FAILED,payload:deviceId };
}